export enum TicketRecurringPeriod {
  Daily = 1,
  Weekly = 2,
  Monthly = 3,
}

export const ticketRecurringOptions = Object.entries(TicketRecurringPeriod)
  .filter(([key, value]) => !isNaN(Number(value)))
  .map(([key, value]) => ({ id: Number(value), title: key }));
